import React from 'react';
import YouTube from 'react-youtube';
import { trans } from '@spotahome/soyuz/client';

import Heading from '@spotahome/ui-library/lib/components/Heading';

// Styles
import './Video.scss';

const VIDEO_ID = 'uGdHxBkezoM';
const opts = {
  height: '367',
  width: '653'
};

const onReady = event => {
  event.target.pauseVideo();
};

const Video = () => (
  <div className="grid">
    <Heading
      level={2}
      size="large"
      className="heading-mb mb-xl"
      text={trans('home-checker.become')}
    />
    <div className="video">
      <YouTube videoId={VIDEO_ID} opts={opts} onReady={onReady} />
    </div>
  </div>
);

export default Video;
